import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { LogBookFeature } from '../../shared/model/logbook.model';
import { HALResponse } from '../../shared/model/app.model';
import { LogBookRootScopeService } from "app/shared/model/app.model";

@Injectable({
	providedIn: 'root'
})
export class LogBookService {
	private CONFIG_DATA: { [key: string]: any } = {};
	
	private logBookFeatures$?: Observable<LogBookFeature[]>;

	private _LOGBOOK_API_VERSION = '';

	private get $rootScope(): LogBookRootScopeService {
		return this.injector.get('$rootScope');
	}

	get LOGBOOK_API_VERSION() {
		return this._LOGBOOK_API_VERSION;
	}

	set LOGBOOK_API_VERSION(val) {
		if (!this._LOGBOOK_API_VERSION)
		{
			this._LOGBOOK_API_VERSION = val;
		}
		else if (this._LOGBOOK_API_VERSION !== val && !this.$rootScope.versionMismatch)
		{
			this.$rootScope.versionMismatch = true;
			console.log(`Version mismatch.  Server: ${val}, client: ${this._LOGBOOK_API_VERSION}`);
		}
	}
	
	private readonly configUpdateSubject = new Subject();
	readonly configUpdate$ = this.configUpdateSubject.asObservable();

	constructor(
		private http: HttpClient,
		private injector: Injector
	) { }

	getConfigValue(key: string) {
		return this.CONFIG_DATA[key];
	}

	setConfigValue(key: string, value: any) {
		this.CONFIG_DATA[key] = value;
		this.configUpdateSubject.next();
	}
	
	getLogBookFeatures() {
		if (!this.logBookFeatures$) {
			this.logBookFeatures$ = this.http.get<HALResponse<{ logBookFeatures: LogBookFeature[] }>>(
				'/api/logBookFeatures'
			)
			.pipe(
				map(r => r._embedded.logBookFeatures),	
				shareReplay(1)
			);
		}

		return this.logBookFeatures$;
	}
}